module.exports = __webpack_public_path__ + "media/images/kaoawase/hall-list/kaoawase-halllist-5-75bb43cd2d0b4f341aad50a51b189b1f.png";